import { X } from "react-feather";

import { Modal, Button, ModalBody, ModalHeader } from "reactstrap";
import "./Styles/Styles.scss";

const ProcessCancel = ({ open, handleCancel, handleCancelAllProcess }) => {
  return (
    <Modal
      size="sm"
      isOpen={open}
      className="VideoProcess ProcessCancel modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X size={30} role="button" onClick={() => handleCancel(!open)} />
      </ModalHeader>
      <ModalBody>
        <>
          <div className="d-flex justify-content-center">
            <div className="text-center mb-3">
              <h2>Are you sure you want to cancel this task?</h2>
            </div>
          </div>

          <div className="d-flex justify-content-center gap-3 mb-2">
            <Button
              className="video-process-btn"
              size="lg"
              color="outline-primary"
              onClick={() => handleCancel(!open)}
            >
              No
            </Button>
            <Button
              className="video-process-btn"
              size="lg"
              color="primary"
              onClick={handleCancelAllProcess}
            >
              Yes
            </Button>
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default ProcessCancel;
